export default __webpack_public_path__ + "static/media/discount.eac6c555.png";